import { jsx as _jsx } from "react/jsx-runtime";
import { _className, Button, ComponentSync, openContent } from '@nu-art/thunderstorm-frontend';
import { Component_ContentFallback } from '../../Component_ContentFallback/Component_ContentFallback.js';
import './Component_InboxButton.scss';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_Home, PanelKey_Inbox } from '@app/advisor-v5-shared';
import { ICONS } from '@app/styles';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
export class Component_InboxButton extends ComponentSync {
    //######################### Life Cycle #########################
    __onAdvisorMiniChange = () => {
        if (this.mounted)
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.forceFallback = !!nextProps.forceFallback;
        return state;
    }
    //######################### Logic #########################
    onClick = async () => {
        if (ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_Inbox)
            return ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
        ModuleFE_AdvisorMini.openPanel(PanelKey_Inbox);
        ModuleFE_AdvisorAnalytics.trigger.inbox.inbox_open();
    };
    //######################### Render #########################
    render() {
        const className = _className('c__inbox-button', 'c__utility-button', ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_Inbox && 'active');
        return _jsx(Button, { className: className, variant: 'primary', onClick: this.onClick, ...(this.state.forceFallback && openContent.tooltip.top('tt__inbox-button', 'Orders', { offset: 10 })), children: _jsx(Component_ContentFallback, { forceFallback: this.state.forceFallback, content: () => 'Orders', fallback: () => _jsx(ICONS.advisor_avn_orders.component, {}) }) });
    }
}
//# sourceMappingURL=Component_InboxButton.js.map